import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

class MDClinician {
    public Id: string = "";
    public Name: string = "";
    public Identifier: string = "";
    public Speciality: string = "";
    public PracticianStatus: string = "";
    public Address: string = "";
    public PhoneNumber: string = "";
    public Facility: string = "";
    public PermitType: string = "";
    public Email: string = "";
    public Gender: string = "";
    public RamqNumber: string = "";
    public LicenceNumber: string = "";
    public Note: string = "";
    public Fax: string = "";
    public EnrolmentDate: Date;

    // for edition
    public IsPhoneNumberValid: boolean = true;
    public IsFaxNumberValid: boolean = true;
    public AvailableStatusLookups: FlatLookupView[];
    public AvailablePermitTypeLookups: FlatLookupView[];
}

export { MDClinician };
